module.exports = __webpack_public_path__ + "img/map-pin.db36f2e8.svg";